module.exports = __webpack_public_path__ + "img/35.e1c0ffbe.webp";